// extracted by mini-css-extract-plugin
export default {"canvas":"ImageCanvas_canvas__ibPZK","container":"ImageCanvas_container__fpbGC","deleteButton":"ImageCanvas_deleteButton__kpa4O"};